import Popup from "../User/popup";
export const ContentLoading = () => {
    return <Popup show={true}>
        <div className="flex items-center justify-center w-full h-full">
            <img className="content-loading-img animate-spin" src="/assets/settings/loader.svg" alt='content loading'/>
        </div>
    </Popup>
};